module.exports = __webpack_public_path__ + "img/notice_前置工序完工.jpg";